export const getTourSteps = (isAdmin, surveyCompleted, t, drawerOpen, setDrawerOpen, tourType = 'main') => {
    const openDrawer = () => {
        if (!drawerOpen) {
            setDrawerOpen(true);
        }
    };

    const closeDrawer = () => {
        if (drawerOpen) {
            setDrawerOpen(false);
        }
    };

    if (tourType === 'surveyIntroduction') {
        return getSurveyIntroductionTourSteps(t);
    }
    
    if (tourType === 'overview') {
        return getOverviewTourSteps(t);
    }
    
    if (tourType === 'cognitivePattern') {
        return getCognitivePatternTourSteps(t);
    }

    if (isAdmin) {
        return getAdminTourSteps(t, openDrawer, closeDrawer);
    } else if (!surveyCompleted) {
        return getPreSurveyTourSteps(t, openDrawer, closeDrawer);
    } else {
        return getPostSurveyTourSteps(t, openDrawer, closeDrawer);
    }
};

const getCognitivePatternTourSteps = (t) => {
    return [
        {
            target: 'body',
            content: t('cognitivePatternTour.welcome'),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="cognitive-pattern-chart"]',
            content: t('cognitivePatternTour.mainChart'),
            placement: 'bottom',
            disableBeacon: true,
        },
        {
            target: '[data-tour="cognitive-pattern-info"]',
            content: t('cognitivePatternTour.infoButton'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="peak-indicator"]',
            content: t('cognitivePatternTour.peakIndicator'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="slump-indicator"]',
            content: t('cognitivePatternTour.slumpIndicator'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="notification-schedule"]',
            content: t('cognitivePatternTour.notificationSchedule'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="pattern-summary"]',
            content: t('cognitivePatternTour.patternSummary'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="performance-metrics"]',
            content: t('cognitivePatternTour.performanceMetrics'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: 'body',
            content: t('cognitivePatternTour.complete'),
            placement: 'center',
            disableBeacon: true,
        }
    ];
};

const getOverviewTourSteps = (t) => {
    return [
        {
            target: 'body',
            content: t('overviewTour.welcome'),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="help-icon"]',
            content: t('overviewTour.helpIcon'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="action-buttons"]',
            content: t('overviewTour.actionButtons'),
            placement: 'bottom',
            disableBeacon: true,
        },
        {
            target: '[data-tour="refresh-button"]',
            content: t('overviewTour.refreshButton'),
            placement: 'bottom',
            disableBeacon: true,
        },
        {
            target: '[data-tour="download-report-button"]',
            content: t('overviewTour.downloadButton'),
            placement: 'bottom',
            disableBeacon: true,
        },
        {
            target: '[data-tour="survey-progress-card"]',
            content: t('overviewTour.surveyProgressCard'),
            placement: 'right',
            disableBeacon: true,
        },
        {
            target: '[data-tour="calendar-toggle"]',
            content: t('overviewTour.calendarToggle'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="progress-bar-toggle"]',
            content: t('overviewTour.progressBarToggle'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="export-button"]',
            content: t('overviewTour.exportButton'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="extend-observation-button"]',
            content: t('overviewTour.extendObservationButton'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="observation-periods-card"]',
            content: t('overviewTour.observationPeriodsCard'),
            placement: 'right',
            disableBeacon: true,
        },
        {
            target: '[data-tour="daily-survey-chart-card"]',
            content: t('overviewTour.dailySurveyChartCard'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="performance-chart-card"]',
            content: t('overviewTour.performanceChartCard'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: '[data-tour="todo-list-card"]',
            content: t('overviewTour.todoListCard'),
            placement: 'left',
            disableBeacon: true,
        },
        {
            target: 'body',
            content: t('overviewTour.complete'),
            placement: 'center',
            disableBeacon: true,
        }
    ];
};

const getSurveyIntroductionTourSteps = (t) => {
    return [
        {
            target: 'body',
            content: t('surveyIntroTour.welcome'),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="edit-button"]',
            content: t('surveyIntroTour.editButton'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="edit-form"]',
            content: t('surveyIntroTour.fillForm'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="firstname-field"]',
            content: t('surveyIntroTour.requiredFields'),
            placement: 'bottom',
            disableBeacon: true,
        },
        {
            target: '[data-tour="save-button"]',
            content: t('surveyIntroTour.saveButton'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: '[data-tour="next-button"]',
            content: t('surveyIntroTour.nextButton'),
            placement: 'top',
            disableBeacon: true,
        },
        {
            target: 'body',
            content: t('surveyIntroTour.complete'),
            placement: 'center',
            disableBeacon: true,
        }
    ];
};

const getPreSurveyTourSteps = (t, openDrawer, closeDrawer) => {
    return [
        {
            target: 'body',
            content: t('tour.welcomePreSurvey'),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.navbar',
            content: t('tour.navbar'),
            placement: 'bottom',
        },
        {
            target: '[aria-label="menu"]',
            content: t('tour.menuButtonPreSurvey'),
            placement: 'right',
            beforeStep: closeDrawer,
        },
        {
            target: '.MuiDrawer-paper',
            content: t('tour.menuOpenPreSurvey'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="survey-introduction"]',
            content: t('tour.surveyIntroduction'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="personal-info"]',
            content: t('tour.personalInfoPreSurvey'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: 'body',
            content: t('tour.completePreSurvey'),
            placement: 'center',
            disableBeacon: true,
            beforeStep: closeDrawer,
        }
    ];
};

const getPostSurveyTourSteps = (t, openDrawer, closeDrawer) => {
    return [
        {
            target: 'body',
            content: t('tour.welcomePostSurvey'),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.navbar',
            content: t('tour.navbar'),
            placement: 'bottom',
        },
        {
            target: '[aria-label="menu"]',
            content: t('tour.menuButtonPostSurvey'),
            placement: 'right',
            beforeStep: closeDrawer,
        },
        {
            target: '.MuiDrawer-paper',
            content: t('tour.menuOpenPostSurvey'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="personal-info"]',
            content: t('tour.personalInfo'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="overview"]',
            content: t('tour.overview'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="daily-survey"]',
            content: t('tour.dailySurvey'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="performance-question"]',
            content: t('tour.performanceQuestion'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="calendar"]',
            content: t('tour.calendar'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="body-metrics"]',
            content: t('tour.bodyMetrics'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="cognitive-patterns"]',
            content: t('tour.cognitivePatterns'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="result"]',
            content: t('tour.result'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: 'body',
            content: t('tour.completePostSurvey'),
            placement: 'center',
            disableBeacon: true,
            beforeStep: closeDrawer,
        }
    ];
};

const getAdminTourSteps = (t, openDrawer, closeDrawer) => {
    return [
        {
            target: 'body',
            content: t('tour.welcomeAdmin'),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.navbar',
            content: t('tour.navbar'),
            placement: 'bottom',
        },
        {
            target: '[aria-label="menu"]',
            content: t('tour.menuButtonAdmin'),
            placement: 'right',
            beforeStep: closeDrawer,
        },
        {
            target: '.MuiDrawer-paper',
            content: t('tour.menuOpenAdmin'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="personal-info"]',
            content: t('tour.personalInfoAdmin'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="user-list"]',
            content: t('tour.userList'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="set-notification"]',
            content: t('tour.setNotification'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: '[data-tour="documentation"]',
            content: t('tour.documentation'),
            placement: 'right',
            beforeStep: openDrawer,
            disableBeacon: true,
        },
        {
            target: 'body',
            content: t('tour.completeAdmin'),
            placement: 'center',
            disableBeacon: true,
            beforeStep: closeDrawer,
        }
    ];
};

export const tourStyles = {
    options: {
        primaryColor: '#1976d2',
        textColor: '#333',
        backgroundColor: '#fff',
        arrowColor: '#fff',
        overlayColor: 'rgba(0, 0, 0, 0.5)',
        spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
        beaconSize: 36,
        zIndex: 10000,
    },
    buttonNext: {
        backgroundColor: '#1976d2',
        color: '#fff',
        borderRadius: '4px',
        padding: '8px 16px',
        fontSize: '14px',
        fontWeight: '500',
    },
    buttonBack: {
        color: '#1976d2',
        marginRight: 'auto',
        fontSize: '14px',
    },
    buttonSkip: {
        color: '#666',
        fontSize: '14px',
    },
    tooltip: {
        borderRadius: '8px',
        fontSize: '14px',
        padding: '15px',
    },
    tooltipContent: {
        textAlign: 'left',
        paddingTop: '5px',
        paddingBottom: '10px',
    },
    spotlight: {
        borderRadius: '4px',
    }
};